import { ErrorHandler, Injectable, ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core'
import { EnvironmentService } from './environment.service'

import * as Sentry from '@sentry/browser'
import { LogRocketService } from './log-rocket.service'

@Injectable({ providedIn: 'root' })
export class SentryErrorHandler implements ErrorHandler {
    private static Sentry = Sentry
    constructor(
        private environmentService: EnvironmentService,
        private logRocket: LogRocketService
    ) {}

    init() {
        SentryErrorHandler.Sentry.init({
            dsn: this.environmentService.sentryDsn,
        })
        this.logRocket.logRocket$.subscribe((logRocket) => {
            if (logRocket) {
                logRocket.getSessionURL((sessionURL) => {
                    SentryErrorHandler.Sentry.configureScope((scope) => {
                        scope.setExtra('sessionURL', sessionURL)
                    })
                })
            }
        })
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    handleError(error: any) {
        SentryErrorHandler.Sentry.captureException(error.originalError || error)
    }
}

@NgModule({})
export class SentryModule {
    constructor(@Optional() @SkipSelf() parentModule: SentryModule) {
        if (parentModule) {
            throw new Error('SentryModule is already loaded.  Import it in the AppModule only')
        }
    }

    static forRoot(): ModuleWithProviders<SentryModule> {
        return {
            ngModule: SentryModule,
            providers: [{ provide: ErrorHandler, useClass: SentryErrorHandler }],
        }
    }
}
